/** Batch */
export const CHANGE_BATCH_STATUS_APPROVE = 'CHANGE_BATCH_STATUS_APPROVE'
export const CHANGE_BATCH_STATUS_UNPAID = 'CHANGE_BATCH_STATUS_UNPAID'
